import { Visibility, VisibilityOff } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  Link,
  TextField,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Link as DomLink } from "react-router-dom";
import * as Yup from "yup";
import { getAllImagesAndUrl } from "../../../pages/BookingDashboard/apis/BrandingModalApi";
import { getHotel, login, masterLogin } from "../_redux/authCrud";
import * as auth from "../_redux/authRedux";
import { useTranslation } from "react-i18next";
import i18n from "./i18n";
import NewEmailSuccessPage from "./NewEmailSuccessPage";
import mainLogo from "../../../../../src/_metronic/layout/components/header/header-menu/logo.png";
import moment from "moment";

const NewEmailSuccessPage1 = (props) => {
  const { t } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(props.selectedLanguage);
  }, [props.selectedLanguage]);

  const LoginSchema = Yup.object().shape({
    passw: Yup.string().required(`${t("Password is required")}`),
  });
  const MasterLoginSchema = Yup.object().shape({
    username: Yup.string().required(`${t("master email is required")}`),
    passw: Yup.string().required(`${t("master password is required")}`),
  });
  const masterAdminCheck =
    window.location.pathname.split("/")[1] === "masterAdmin" ? true : false;
  // const theme = useTheme()
  // const matches = useMediaQuery('(min-width:600px)');
  const [loading, setLoading] = useState(false);
  const [invalid, setInvalid] = useState(false);
  const [invalidLogin, setInvalidLogin] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { loginTrue, mailId } = props;
  const formik = useFormik({
    initialValues: { passw: "" },
    validationSchema: LoginSchema,
    onSubmit: async (values) => {
      validUser(values);
    },
  });

  const masterFormik = useFormik({
    initialValues: { username: "", passw: "" },
    validationSchema: MasterLoginSchema,
    onSubmit: async (values) => {
      validMasterUser(values);
    },
  });

  const validMasterUser = async (values) => {
    setLoading(true);
    setInvalid(false);
    try {
      const temporary = await masterLogin(
        mailId,
        values.username,
        values.passw
      );
      const resp = temporary.data;
      const hotelData = await getHotel(
        mailId,
        resp.groupProperty,
        `${resp.token}||master`
      );
      const temp = Object.assign(resp);
      temp.hotels = hotelData.data;
      temp.email = mailId;
      temp.token = `${resp.token}||master`;
      localStorage.setItem("hotelId", hotelData.data[0].hotelId);
      localStorage.setItem("token", `${resp.token}||master`);
      localStorage.setItem("rootEmail", values.username);
      setLoading(false);
      props.login(temp);
      localStorage.setItem("HotelEmail", mailId);
    } catch (e) {
      setInvalid(true);
      setLoading(false);
    }
  };

  const validUser = async (values) => {
    setLoading(true);
    setInvalid(false);
    try {
      const temporary = await login(mailId, values.passw);
      localStorage.setItem("HotelEmail", mailId);
      if (temporary.data.token === "Invalid login hours") {
        setInvalidLogin(true);
        setLoading(false);
      } else {
        const resp = temporary.data;
        const hotelData = await getHotel(
          mailId,
          resp.groupProperty,
          resp.token
        );
        const temp = Object.assign(resp);
        temp.hotels = hotelData.data;
        temp.email = mailId;
        localStorage.setItem("hotelId", hotelData.data[0].hotelId);
        localStorage.setItem("token", resp.token);
        setLoading(false);
        props.login(temp);
        localStorage.setItem("HotelEmail", mailId);
      }
    } catch (e) {
      setInvalid(true);
      setLoading(false);
    }
  };

  const [showHelper, setshowHelper] = useState("");
  useEffect(async () => {
    await getAllData();
  }, []);

  const getAllData = async () => {
    try {
      const data = await getAllImagesAndUrl();
      setshowHelper(data.status);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Box display="flex" width="100vw" height="100vh">
      {/* LEFT 50% */}
      <Box
        flex={1}
        bgcolor="#121212"
        color="white"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        px={4}
      >
        <img
          alt="logo"
          // src={imageData?.logoUrl}
          src={mainLogo}
          style={{ maxHeight: "100px", maxWidth: "150px", filter: "invert(1)" }}
        />
        <Typography
          variant="h6"
          mb={4}
          style={{ fontWeight: "bold", fontSize: "1.8rem" }}
        >
          {t("Truly all-in-one platform for hotels and vacation rentals")}
        </Typography>

        <Typography
          variant="h4"
          color="white"
          mb={2}
          style={{ marginTop: "10px", marginBottom: "6rem" }}
        >
          {t("empowering 3500+ hotels worldwide")}
        </Typography>
        <Typography variant="h5" color="gray" mb={2}>
          {t("Download our app")}
        </Typography>
        <Box display="flex" gap={2}>
          <div className="d-flex justify-content-between ">
            <img
              style={{
                height: "4rem",
                cursor: "pointer",
                width: "11rem",
                marginTop: "7px",
                borderRadius: "10px",
                border: "0.8px solid #A3A3A3",
              }}
              onClick={() => {
                window.open(
                  "https://apps.apple.com/us/app/stayflexi-orchestra/id1498345123",
                  "_blank"
                );
              }}
              src={
                "https://prodimagesbucket.blob.core.windows.net/misc/GPLAYS.png"
              }
            />
            <img
              style={{
                height: "73px",
                width: "12rem",
                cursor: "pointer",
                marginTop: "-5px",
              }}
              onClick={() => {
                window.open(
                  "https://play.google.com/store/apps/details?id=com.stayflexi.platform",
                  "_blank"
                );
              }}
              src={
                "https://prodimagesbucket.blob.core.windows.net/misc/5a902dbf7f96951c82922875.png"
              }
            />
          </div>
        </Box>
      </Box>

      {/* RIGHT 50% */}
      <Box flex={1} display="flex" flexDirection="column" px={6}>
        {/* Centered form */}
        <Box
          flexGrow={1}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Box
            component="form"
            noValidate
            onSubmit={
              masterAdminCheck ? masterFormik.handleSubmit : formik.handleSubmit
            }
            sx={{ width: "100%", maxWidth: 400 }}
          >
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Typography variant="h3" pb={1}>
                  {masterAdminCheck ? t("Master login") : t("Welcome back")}
                </Typography>
                <Typography variant="body1" mb={2}>
                  {mailId}
                </Typography>
              </Grid>

              {masterAdminCheck ? (
                <>
                  <Grid item xs={12}>
                    <TextField
                      autoFocus
                      fullWidth
                      name="username"
                      id="username"
                      value={masterFormik.values.username}
                      onChange={(e) => {
                        masterFormik.setFieldValue("username", e.target.value);
                        if (invalid) setInvalid(false);
                      }}
                      onBlur={masterFormik.handleBlur}
                      error={
                        (masterFormik.touched.username &&
                          Boolean(masterFormik.errors.username)) ||
                        invalid
                      }
                      helperText={
                        (masterFormik.touched.username &&
                          masterFormik.errors.username) ||
                        (invalid && t("Invalid master email"))
                      }
                      placeholder="Master email"
                      sx={{
                        "& legend": { display: "none" }, // remove notch
                      }}
                      // label={t("Master email")}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      name="passw"
                      id="passw"
                      type={showPassword ? "text" : "password"}
                      value={masterFormik.values.passw}
                      onChange={(e) => {
                        masterFormik.setFieldValue("passw", e.target.value);
                        if (invalid) setInvalid(false);
                      }}
                      onBlur={masterFormik.handleBlur}
                      error={
                        (masterFormik.touched.passw &&
                          Boolean(masterFormik.errors.passw)) ||
                        invalid
                      }
                      helperText={
                        (masterFormik.touched.passw &&
                          masterFormik.errors.passw) ||
                        (invalid && t("Invalid master password"))
                      }
                      placeholder="Master password"
                      // label={t("Master password")}
                      sx={{
                        "& legend": { display: "none" }, // remove notch
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowPassword(!showPassword)}
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </>
              ) : (
                <>
                  <Grid item xs={12}>
                    <TextField
                      autoFocus
                      fullWidth
                      name="passw"
                      id="passw"
                      type={showPassword ? "text" : "password"}
                      value={formik.values.passw}
                      onChange={(e) => {
                        formik.setFieldValue("passw", e.target.value);
                        if (invalid) setInvalid(false);
                        if (invalidLogin) setInvalidLogin(false);
                      }}
                      onBlur={formik.handleBlur}
                      error={
                        (formik.touched.passw &&
                          Boolean(formik.errors.passw)) ||
                        invalid ||
                        invalidLogin
                      }
                      helperText={
                        (formik.touched.passw && formik.errors.passw) ||
                        (invalid && t("Invalid password")) ||
                        (invalidLogin && t("Invalid login hours"))
                      }
                      sx={{
                        "& legend": { display: "none" }, // remove notch
                      }}
                      placeholder="Password"
                      // label={t("Password")}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowPassword(!showPassword)}
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  {showHelper !== "ENABLED" && (
                    <Grid item xs={12}>
                      <Link
                        underline="hover"
                        component={DomLink}
                        to={{
                          pathname: "/auth/forget-password",
                          state: { email: mailId },
                        }}
                      >
                        {t("Forgot your password")}?
                      </Link>
                    </Grid>
                  )}
                </>
              )}

              <Grid item xs={12}>
                <LoadingButton
                  fullWidth
                  size="large"
                  loading={loading}
                  type="submit"
                  variant="contained"
                >
                  {t("Sign In")}
                </LoadingButton>
              </Grid>

              <Grid item xs={12} container justifyContent="center">
                <Link onClick={loginTrue} underline="hover" to="/">
                  {t("Back")}
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>

        {/* Footer at bottom, centered */}
        <Typography align="center" p={2} sx={{ color: "#5C5C5C" }}>
          © {moment().format("YYYY")}{" "}
          {t("Stayflexi, Inc. San Francisco, California")}
        </Typography>
      </Box>
    </Box>
  );
};

export default injectIntl(connect(null, auth.actions)(NewEmailSuccessPage1));
